export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-30-C-Nav-WEB-345985620f9cb31dcee30844f80d6371.png";